/* eslint-disable import/extensions */
import ViewMessages from "./view-messages.js";
import BlockUI from "./block-ui.js";
import MultiPageRegisterForm from "./multi-page-register-form.js";
import Schedule from "./schedule.js";
import AppointmentConfirmation from "./appointment-confirmation";
import CustomerConfig from "./customer-config";
import AppointmentsService from "./appointments-service.js";
import Resizer from "./resizer.js";
import Scroller from "./scroller.js";
import LinkInterceptor from "./link-interceptor";
import LoginModal from "./login-modal";

window.customerConfig = null;
window.resizer = null;
window.scroller = null;

window.setStyle = (css) => {
  $(() => {
    const $style = $(`<style></style>`);
    $style.text(css);

    $("head").append($style);
  });
}

window.embeddedRedirect = () => {
  // Detect if page is embedded in an iframe, and redirect to correct page, if needed.
  const url = new URL(window.location.href);
  const isEmbeddedPage = url.pathname.toLowerCase().startsWith("/embed");
  if (window === window.parent && isEmbeddedPage) {
    // Not embedded & on embedded page.
    // Redirect to standard page.
    url.pathname = url.pathname.toLowerCase().replace("/embed", "");
    window.location.href = url.href;
  }
  else if (window !== window.parent && !isEmbeddedPage) {
    // Embedded & on standard page.
    // Redirect to embedded page.
    url.pathname = `/embed${url.pathname}`;
    window.location.href = url.href;
  }
};

window.displayViewMessages = (messages, selector) => {
  $(() => {
    const vm = new ViewMessages();
    vm.parse(messages);

    if (!vm.empty) {
      selector = selector ?? "body";
      const $container = $(selector);
      vm.display($container);
      vm.scrollTo();
    }
  })
}

window.clearViewMessages = (selector) => {
  const vm = new ViewMessages();
  selector = selector ?? "body";
  const $container = $(selector);
  vm.clear($container);
}

window.initCommon = (config) => {
  $(() => {
    window.customerConfig = new CustomerConfig(config);

    // Apply config settings
    window.initNavbar();

    if (window.customerConfig.hideLogo) {
      $(".logo-wrap").addClass("hidden");
    } else {
      $(".logo-wrap").removeClass("hidden");
    }

    window.resizer = new Resizer();
    window.resizer.init();

    window.scroller = new Scroller(config.disableScrolling);

    // Messages are attached to the body on page load
    window.displayViewMessages($("body").attr("data-messages"));
  });
};

window.initNavbar = () => {
  $(() => {
    if (window.customerConfig.hideNavbar) {
      $("#main-navbar").addClass("hidden");
      $("#minimal-navbar").removeClass("hidden");
    } else {
      $("#main-navbar").removeClass("hidden");
      $("#minimal-navbar").addClass("hidden");
    }
  })
}

window.initEmbedBook = (options) => {
  $(async () => {
    try {
      $("html").css("height", "auto");

      const content = await AppointmentsService.getBookContent();
      $("#content").html(content);

      await window.initBookPage(options);
    } catch (errResp) {
      switch (errResp.status) {
        case 401:
          // Retry after logging in
          $(".spinner").addClass("hidden");
          // Pause scrolling for the login modal as this will occur on page load,
          // and may confuse users
          window.scroller.pause();
          await mustLogin();
          window.scroller.unpause();

          $(".spinner").removeClass("hidden");
          window.initEmbedBook(options);
          break;

        default:
          console.error(errResp);
          alert("There was an error loading the booking page content, please reload the page and try again.\n\n"
            + "If this problem persists please contact the dental surgery to report the problem.");
      }
    } finally {
      $(".spinner").addClass("hidden");
    }
  });
};

mustLogin = () => {
  const linkInterceptor = new LinkInterceptor();
  linkInterceptor.init();

  // Uses a manual promise instead of async/await because we need to recursively call
  // mustLogin in the bootbox alert's asyncronous callback, which can't be awaited.
  return new Promise((resolve, reject) => {
    // Doesn't reject, keeps recursively trying to log in until successful.

    requestLogin(linkInterceptor).then(
      resolve,
      // If login fails, show the error reason and then retry the login.
      (error) => {
        console.error(error);

        let message;
        if (error.message === "Login cancelled.") {
          message = "Login cancelled. Please log in or register to book an appointment.";
        } else if (error.message === "The server could not be reached.") {
          message = "The server could not be reached. Please try again later.";
        } else {
          message = "There was a problem during login or registration. Please try again.";
        }

        bootbox.alert({
          message,
          callback: () => {
            mustLogin().then(resolve);
          },
          backdrop: true,
        });
      }
    )
  })
}

requestLogin = async (linkInterceptor) => {
  const modal = new LoginModal(linkInterceptor);

  try {
    await modal.requestLogin();
  } catch (error) {
    let message = "";
    if (error.message === "Login cancelled.") {
      message = error.message;
    } else {
      console.error(error);
      message = "Could not log you in, please try again.";
    }

    throw new Error(message);
  } finally {
    modal.close();
  }

  // Login success
}

window.initLoginNavItem = () => {
  $(() => {
    const $logoffLink = $("a.logoff");
    $logoffLink.off("click").on("click", () => {
      $(".logout-form").first().submit();
    });
  });
};

window.initLoginPage = () => {
  $(() => {
    const $frmLogin = $("#login-form");
    $frmLogin.on("submit", (e) => {
      if (!$frmLogin.valid()) {
        e.preventDefault();
        return;
      }

      BlockUI.blockWithId("login-register", "Authenticating...");
    });
  });
};

window.initLoginSuccessPage = () => {
  $(() => {
    $(document).trigger("login-success");
  });
};

window.initRegisterPage = () => {
  $(() => {
    const register = new MultiPageRegisterForm();
    register.init();

    // Scroll to form top when moving between pages
    register.eventTarget.on("next-prev.register-form", (e) => {
      window.scroller.scrollToElemTop(register.form);
    });
  });
};

window.initHomePage = () => {
  $(() => {
    $(".appointments").DataTable({
      lengthChange: false,
      searching: false,
      order: [[0, "desc"]],
      responsive: true,
    });
  });
};

window.initBookPage = async (options) => {
  $(async () => {
    const schedule = new Schedule(options);
    await schedule.init();
    await schedule.refreshNavbar();
  });
};

window.initAppointmentCardPage = () => {
  $(() => {
    const confirmation = new AppointmentConfirmation();
    confirmation.init();
  });
};
